"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _webexCore = require("@webex/webex-core");
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * @class
 * @extends {Lyra}
 * @memberof Lyra
 */
var Device = _webexCore.WebexPlugin.extend({
  namespace: 'Lyra',
  /**
   * Gets the audio state of the device
   * @param {Types~LyraSpace} space
   * @param {string} space.url
   * @returns {Promise<LyraAudioState>} {volume, microphones, url}
   */
  getAudioState: function getAudioState(space) {
    return this.webex.request({
      method: 'GET',
      uri: "".concat(space.url, "/audio")
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * Updates audio state for lyra device, should be called every 10 minutes or
   * when mic or volume state is changed
   * @param {Types~LyraSpace} space
   * @param {string} space.url
   * @param {Types~LyraAudioState} audioState
   * @param {object} audioState.volume optional
   * @param {boolean} audioState.volume.level
   * @param {object} audioState.microphones optional
   * @param {boolean} audioState.microphones.muted
   * @param {string} audioState.deviceUrl
   * @returns {Promise}
   */
  putAudioState: function putAudioState(space) {
    var audioState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!audioState.deviceUrl) {
      return _promise.default.reject(new Error('audioState.deviceUrl is required'));
    }
    return this.webex.request({
      method: 'PUT',
      uri: "".concat(space.url, "/audio"),
      body: audioState
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * Mutes lyra device
   * @param {Types~LyraSpace} space
   * @param {string} space.url
   * @returns {Promise}
   */
  mute: function mute(space) {
    return this.webex.request({
      method: 'POST',
      uri: "".concat(space.url, "/audio/microphones/actions/mute/invoke")
    });
  },
  /**
   * Unmutes lyra device
   * @param {Types~LyraSpace} space
   * @param {string} space.url
   * @returns {Promise}
   */
  unmute: function unmute(space) {
    return this.webex.request({
      method: 'POST',
      uri: "".concat(space.url, "/audio/microphones/actions/un-mute/invoke")
    });
  },
  /**
   * Increases lyra device's volume
   * @param {Types~LyraSpace} space
   * @param {string} space.url
   * @returns {Promise}
   */
  increaseVolume: function increaseVolume(space) {
    return this.webex.request({
      method: 'POST',
      uri: "".concat(space.url, "/audio/volume/actions/increase/invoke")
    });
  },
  /**
   * Decreases lyra device's volume
   * @param {Types~LyraSpace} space
   * @param {string} space.url
   * @returns {Promise}
   */
  decreaseVolume: function decreaseVolume(space) {
    return this.webex.request({
      method: 'POST',
      uri: "".concat(space.url, "/audio/volume/actions/decrease/invoke")
    });
  },
  /**
   * Sets lyra device's volume but should use increase and decrease api instead
   * @param {Types~LyraSpace} space
   * @param {string} space.url
   * @param {integer} level to be set
   * @returns {Promise}
   */
  setVolume: function setVolume(space) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return this.webex.request({
      method: 'POST',
      uri: "".concat(space.url, "/audio/volume/actions/set/invoke"),
      body: {
        level: level
      }
    });
  },
  version: "2.59.4"
});
var _default = Device;
exports.default = _default;
//# sourceMappingURL=device.js.map
